import { Box, Typography, Tooltip } from '@mui/material';
import styles from './UserSessionData.module.scss';
import {useTranslation} from 'react-i18next';
import { UserData } from '../../common/Interfaces';
import { Logout, AccountCircle } from '@mui/icons-material';
import BorderlessButton from '../common/formControls/buttons/BordlessButton';

export default function UserSessionData ({UserName, UserFullName, handleLogout}: UserData){
    const {t} = useTranslation();

    return (<Box className={styles.horizontalContainer}>
        <BorderlessButton id="LogoutButton" 
                        label={
                        <Box className={styles.horizontalContainer}>
                            <Logout/>
                            <Typography className={styles.normalText}>
                                {t("LOGOUT")}
                            </Typography>
                        </Box>} 
                        
                        onclickHandler={() => {handleLogout();}} 
        />

        <Tooltip
            title={
                <Box className={styles.container}>
                    <Typography className={styles.normalText}>
                            {UserName}
                    </Typography>

                    <Typography className={styles.normalText}>
                        {UserFullName}
                    </Typography>

                    
                </Box>
            }
        >
            <AccountCircle/>
        </Tooltip>
    </Box>)
}